<div class="row d-flex justify-content-center">
    <div class="col-md-6 text-center">
        <h1>Filtri</h1>
        <form [formGroup]="formFiltri">
        <mdb-form-control class="mb-3">
            <mdb-select formControlName="selMarket" [filter]="true" [visibleOptions]="10">
              <mdb-option [value]="'all'" (click)="filtraDati()">Tutti i mercati</mdb-option>
                <mdb-option *ngFor="let option of markets" [value]="option.market" (click)="filtraDati()">{{
                    option.market
                    }}</mdb-option>
            </mdb-select>
            <label mdbLabel class="form-label">Seleziona il Mercato</label>
        </mdb-form-control>
        
        <mdb-form-control class="mb-3">
            <mdb-select formControlName="selDayweek">
              <mdb-option [value]="0" (click)="filtraDati()">Tutti i giorni</mdb-option>
                <mdb-option *ngFor="let option of days" [value]="option.value" (click)="filtraDati()">{{
                    option.label
                    }}</mdb-option>
            </mdb-select>
            <label mdbLabel class="form-label">Seleziona il Giorno</label>
        </mdb-form-control>
    </form>
    </div>
</div>

<div class="datatable mt-4">
    <table
      class="table datatable-table"
      mdbTable
      mdbTableSort
      #table="mdbTable"
      #sort="mdbTableSort"
      [dataSource]="tableData"
      [pagination]="pagination"
      [sort]="sort"
    >
      <thead class="datatable-header">
        <tr>
          <th *ngFor="let header of headers" [mdbTableSortHeader]="header" scope="col">
            {{ header | titlecase }}
          </th>
        </tr>
      </thead>
      <tbody class="datatable-body">
        <tr *ngFor="let data of table.data" scope="row">
          <td>
            {{ nomeGiorno(data.dayweek) }}
          </td>
          <td>
            {{ data.market }}
          </td>
          <td>
            {{ data.swing=='1' ? 'Swing' : 'BreakOut' }}
          </td>
          <td>
            {{ data.verso }}
          </td>
          <td>
            {{ data.profit | number : '1.5-5' }}
          </td>
          <td>
            {{ data.num }}
          </td>
          <td>
            {{ data.puntiop | number: '1.1-1' }}
          </td>
          <td>
            {{ data.numpos/data.num*100 | number: '2.2-2' }} %
          </td>
        </tr>
      </tbody>
    </table>
    <mdb-table-pagination #pagination></mdb-table-pagination>
  </div>
  
